import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { SwalService } from '@shared/utils/swal.service';
import { TipoCarteraService } from '@p-p-portafolio/services/tipoCartera.service';
import { TipoCartera } from "@p-p-portafolio/interfaces/tipoCartera";
import Swal from 'sweetalert2';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-tipoCartera',
  templateUrl: './tipoCartera.component.html',
  providers: [MessageService]
})
export class TipoCarteraComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedTipoCartera: TipoCartera | null = null;
  dataSource: TipoCartera[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns: Column[] = [
    { field: 'sCartera', header: 'Clave Tipo cartera' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private messageService: MessageService,
    private tipoCarteraService: TipoCarteraService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this.tipoCarteraService.getAll().subscribe({
      next: (response) => {
        if (response) {
          this.dataSource = response;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar tipos de cartera:', err);
        this.swalService.error('Error al cargar los datos');
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedTipoCartera = null;
    this.displayDialog = true;
  }

  openUpdate(row: TipoCartera): void {
    this.selectedTipoCartera = { ...row };
    this.displayDialog = true;
  }

  onDialogClosed(): void {
    this.selectedTipoCartera = null;
    this.displayDialog = false;
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.read();
  }

  openDelete(model: TipoCartera) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el tipo de cartera ${model.sCartera}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.tipoCarteraService.delete(model).subscribe({
          next: (response) => {
            if (response.success) {
              this.swalService.success('Eliminado correctamente');
              this.read();
            } else {
              this.swalService.error(response.errors[0]);
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.swalService.error('Error al eliminar');
            this.loading = false;
          }
        });
      }
    });
  }
}
